import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Box, Flex } from "theme-ui";
import { Fonts } from "../../";
export const Statistic = ({ label, stat, mode = "dark" }) => {
    return (_jsx(Flex, { sx: {
            alignItems: "center",
            width: "100%",
            flex: 1,
            justifyContent: "center",
            borderRadius: "100%",
            borderWidth: "1px",
            borderStyle: "solid",
            ":after": {
                pb: "100%",
                content: '" "'
            }
        }, children: _jsxs(Box, { sx: {
                textAlign: "left"
            }, children: [_jsx(Box, { className: "color-mode-title", sx: {
                        fontSize: ["scale6", null, null, null, "scale8"],
                        fontFamily: Fonts.display,
                        lineHeight: 1
                    }, children: stat }), _jsx(Box, { className: "color-mode-title", sx: {
                        mt: 8,
                        maxWidth: ["28ch", null, "18ch", "18ch", "24ch"]
                    }, children: label })] }) }));
};
//# sourceMappingURL=Statistic.js.map